import { render, staticRenderFns } from "./transfrom-customer-info.pug?vue&type=template&id=1ce7e59e&lang=pug&"
import script from "./transfrom-customer-info.ts?vue&type=script&lang=ts&"
export * from "./transfrom-customer-info.ts?vue&type=script&lang=ts&"
import style0 from "./transfrom-customer-info.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports